// extracted by mini-css-extract-plugin
export var hero = "fM4w2nWgB6bqEG4IpyqF";
export var root = "nuFQccKOVxCUVFdLSKSy";
export var title1 = "MO1mX02cLpq_z5qZzCWw";
export var title2 = "NW79MUR05ZY0Sahu5wLt";
export var title3 = "dcATpkkkNb8o5GGYnEO3";